<app-navbar></app-navbar>

<section style="padding-top: 0;">

  <!-- Hero Slider Section -->
  <div class="container mt-2 mt-lg-4">
    <section class="premium-cinematic-hero position-relative">
      <div class="hero-overlay-content">
        <div class="container h-100 d-flex align-items-center">
          <div class="hero-text-box" style="max-width: 600px;">
            <h2
              style="font-size: clamp(28px, 6vw, 46px); font-weight: 800; text-shadow: 2px 4px 10px rgba(0,0,0,0.8); color: #ffffff;">
              সুশিক্ষাই <br> সুন্দর ভবিষ্যতের ভিত্তি</h2>
            <p
              style="font-size: clamp(16px, 4vw, 20px); margin-top: 15px; text-shadow: 1px 2px 8px rgba(0,0,0,0.9); color: #f8fafc; font-weight: 500;">
              শিক্ষা, নৈতিকতা ও প্রযুক্তির সমন্বয়ে <br> আমরা গড়ে তুলছি আলোকিত
              আগামী</p>
            <div class="d-flex mt-4 gap-3">
              <a routerLink="/about-institute" class="hero-btn hero-btn-primary shadow">আমাদের সম্পর্কে জানুন <i
                  class="fa-solid fa-arrow-right ms-2"></i></a>
              <a href="https://vortibd.com/institute/47/483" target="_blank"
                class="hero-btn hero-btn-danger shadow">ভর্তির আবেদন <i class="fa-solid fa-arrow-right ms-2"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div id="heroCarousel" class="carousel slide carousel-fade h-100" data-bs-ride="carousel" data-bs-interval="6000"
        *ngIf="slides.length > 0">
        <div class="carousel-inner h-100">
          <div class="carousel-item h-100" *ngFor="let slide of slides; let i = index" [class.active]="i === 0">
            <img [src]="slide.ImageLink" class="d-block premium-hero-img" alt="Slide {{ i + 1 }}" />
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Quick Links Section -->
  <div class="container">
    <div class="quick-links-section row mx-0">
      <div class="col-6 col-md-4 col-lg-2 p-0">
        <a routerLink="/notice" class="quick-link-item hover-3d">
          <i class="fa-solid fa-bullhorn quick-link-icon"></i>
          <span class="quick-link-text">নোটিশ বোর্ড</span>
        </a>
      </div>
      <div class="col-6 col-md-4 col-lg-2 p-0 border-start">
        <a routerLink="/admission-form" class="quick-link-item hover-3d">
          <i class="fa-solid fa-file-signature quick-link-icon text-danger"></i>
          <span class="quick-link-text">অনলাইন ফর্ম</span>
        </a>
      </div>
      <div class="col-6 col-md-4 col-lg-2 p-0 border-start">
        <a routerLink="/class-routine" class="quick-link-item hover-3d">
          <i class="fa-solid fa-calendar-days quick-link-icon text-success"></i>
          <span class="quick-link-text">ক্লাস রুটিন</span>
        </a>
      </div>
      <div class="col-6 col-md-4 col-lg-2 p-0 border-start">
        <a routerLink="/public-results" class="quick-link-item hover-3d">
          <i class="fa-solid fa-graduation-cap quick-link-icon text-warning"></i>
          <span class="quick-link-text">ফলাফল দেখুন</span>
        </a>
      </div>
      <div class="col-6 col-md-4 col-lg-2 p-0 border-start">
        <a routerLink="/calendar" class="quick-link-item hover-3d">
          <i class="fa-regular fa-calendar-alt quick-link-icon text-danger"></i>
          <span class="quick-link-text">একাডেমিক ক্যালেন্ডার</span>
        </a>
      </div>
      <div class="col-6 col-md-4 col-lg-2 p-0 border-start">
        <a href="https://portal.cloudcampus24.com/" target="_blank" class="quick-link-item hover-3d">
          <i class="fa-solid fa-credit-card quick-link-icon text-info"></i>
          <span class="quick-link-text">ফি পরিশোধ</span>
        </a>
      </div>
    </div>
  </div>

  <!-- Messages & About -->
  <section class="messages-section position-relative py-5"
    style="background-image: url('assets/img/school/images.jfif'); background-size: cover; background-position: center; background-attachment: fixed; background-repeat: no-repeat;">
    <div
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.5); z-index: 0;">
    </div>
    <div class="container position-relative" style="z-index: 1;">
      <div class="row justify-content-center g-4">

        <!-- Institution Introduction -->
        <div class="col-lg-4 col-md-6 d-flex" *ngIf="HomeContent && HomeContent.length > 0">
          <div
            class="message-card hover-3d card glassmorphism p-4 w-100 border-0 shadow-sm rounded-4 d-flex flex-column">
            <h4 class="fw-bold text-success mb-3">{{HomeContent[0].TitleBn || HomeContent[0].TitleEn}}</h4>
            <img *ngIf="HomeContent[0].ShowAttachments && HomeContent[0].ShowAttachments.length > 0"
              [src]="TransformUrl(HomeContent[0].ShowAttachments[0].FilePath)" alt="প্রতিষ্ঠান পরিচিতি"
              class="w-100 rounded-3 mb-3 shadow-sm" style="height: 120px; object-fit: cover;">
            <img *ngIf="!HomeContent[0].ShowAttachments || HomeContent[0].ShowAttachments.length == 0"
              src="../../../../assets/img/about.jpg" alt="প্রতিষ্ঠান পরিচিতি" class="w-100 rounded-3 mb-3 shadow-sm"
              style="height: 120px; object-fit: cover;">
            <p class="text-truncate-lines text-muted"
              style="-webkit-line-clamp: 5; text-align: justify; font-size: 14px; line-height: 1.6;">
              {{ stripHtml(HomeContent[0].DetailsBn || HomeContent[0].DetailsEn) }}
            </p>
            <div class="text-end mt-auto pt-3 border-top" style="border-color: rgba(0,0,0,0.05) !important;">
              <a routerLink="/about-us" class="read-more-btn">আরও পড়ুন <i class="fa-solid fa-arrow-right ms-1"></i></a>
            </div>
          </div>
        </div>

        <!-- Chairman Message -->
        <div class="col-lg-4 col-md-6 d-flex" *ngIf="chairmanMessageData">
          <div
            class="message-card hover-3d card glassmorphism p-4 w-100 border-0 shadow-sm rounded-4 d-flex flex-column">
            <h4 class="fw-bold text-success mb-3">সভাপতি</h4>
            <div class="clearfix mb-3" style="flex-grow: 1; overflow: hidden; max-height: 250px;">
              <img [src]="TransformUrl(chairmanMessageData.GBImagePath)" alt="সভাপতি"
                class="float-start me-3 mb-1 rounded-3 shadow-sm"
                style="width: 120px; height: 140px; object-fit: cover;">
              <p class="text-muted m-0" style="display: block; text-align: justify; font-size: 14px; line-height: 1.6;">
                {{ stripHtml(chairmanMessageData.DetailsBn || chairmanMessageData.DetailsEn) }}
              </p>
            </div>
            <div class="text-end mt-auto pt-3 border-top"
              style="border-color: rgba(0,0,0,0.05) !important; clear: both;">
              <a [routerLink]="getMessageHref('Chairman')" class="read-more-btn">আরও পড়ুন <i
                  class="fa-solid fa-arrow-right ms-1"></i></a>
            </div>
          </div>
        </div>

        <!-- Principal Message -->
        <div class="col-lg-4 col-md-6 d-flex" *ngIf="principalMessageData">
          <div
            class="message-card hover-3d card glassmorphism p-4 w-100 border-0 shadow-sm rounded-4 d-flex flex-column">
            <h4 class="fw-bold text-success mb-3">অধ্যক্ষ</h4>
            <div class="clearfix mb-3" style="flex-grow: 1; overflow: hidden; max-height: 250px;">
              <img [src]="TransformUrl(principalMessageData.GBImagePath)" alt="অধ্যক্ষ"
                class="float-start me-3 mb-1 rounded-3 shadow-sm"
                style="width: 120px; height: 140px; object-fit: cover;">
              <p class="text-muted m-0" style="display: block; text-align: justify; font-size: 14px; line-height: 1.6;">
                {{ stripHtml(principalMessageData.DetailsBn || principalMessageData.DetailsEn) }}
              </p>
            </div>
            <div class="text-end mt-auto pt-3 border-top"
              style="border-color: rgba(0,0,0,0.05) !important; clear: both;">
              <a [routerLink]="getMessageHref('Principal')" class="read-more-btn">আরও পড়ুন <i
                  class="fa-solid fa-arrow-right ms-1"></i></a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- Academic Departments -->
  <section class="academic-departments-section mt-5 py-5">
    <div class="container">
      <div class="text-center d-flex align-items-center justify-content-center pt-3 mb-4">
        <div class="d-flex align-items-center me-3" style="gap: 5px;">
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
        </div>
        <h2 class="fw-bold mb-0" style="font-size: 24px; color: #111;">আমাদের একাডেমিক বিভাগসমূহ</h2>
        <div class="d-flex align-items-center ms-3" style="gap: 5px;">
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
        </div>
      </div>
      <div class="row justify-content-center g-4 mt-2">
        <div class="col-lg-4 col-md-6">
          <div class="department-card hover-3d card" style="border-color: #eaebec; background: #fafafa;">
            <div class="department-icon" style="color: #026928;">
              <i class="fa-solid fa-book-reader"></i>
            </div>
            <div class="department-info">
              <h4 style="color: #026928;">প্রাথমিক বিভাগ</h4>
              <h5>শ্রেণি: প্লে – পঞ্চম শ্রেণি</h5>
              <p>শিশুদের জন্য আনন্দময় শিক্ষার পরিবেশ ও নৈতিক ভিত্তি গড়ে তোলা।</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="department-card hover-3d card"
            style="border-color: rgba(220,53,69,0.2); background: rgba(220,53,69,0.03);">
            <div class="department-icon" style="color: #c82333;">
              <i class="fa-solid fa-book-reader"></i>
            </div>
            <div class="department-info">
              <h4 style="color: #c82333;">মাধ্যমিক বিভাগ</h4>
              <h5>শ্রেণি: ষষ্ঠ - দশম শ্রেণি</h5>
              <p>একাডেমিক উৎকর্ষ ও নৈতিক শিক্ষার সমন্বয়ে ভবিষ্যৎ গড়ার লক্ষ্য।</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="department-card hover-3d card"
            style="border-color: rgba(255,152,0,0.2); background: rgba(255,152,0,0.03);">
            <div class="department-icon" style="color: #ff9800;">
              <i class="fa-solid fa-graduation-cap"></i>
            </div>
            <div class="department-info">
              <h4 style="color: #e68a00;">উচ্চ মাধ্যমিক বিভাগ</h4>
              <h5>শ্রেণি: একাদশ - দ্বাদশ শ্রেণি</h5>
              <p>উচ্চশিক্ষা ও ক্যারিয়ার গঠনে প্রয়োজনীয় প্রস্তুতি প্রদান।</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Statistics -->
  <div class="container" *ngIf="statistics_data && statistics_data.length > 0">
    <div class="statistics-section">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0" *ngFor="let stat of statistics_data">
          <div class="stat-item d-flex align-items-center justify-content-start"
            style="max-width: 230px; margin: 0 auto;">
            <div class="rounded-circle border border-2 d-flex align-items-center justify-content-center me-3"
              [style.border-color]="getStatConfig(stat.ContentCategoryName).color + ' !important'"
              [style.color]="getStatConfig(stat.ContentCategoryName).color"
              style="width: 60px; height: 60px; flex-shrink: 0;">
              <i class="fa-solid fs-3" [ngClass]="getStatConfig(stat.ContentCategoryName).icon"></i>
            </div>
            <div class="stat-info text-start text-white">
              <h3 class="mb-0 fw-bold" style="font-size: 22px;">{{ stripHtml(stat.DetailsBn) ||
                stripHtml(stat.DetailsEn) }}</h3>
              <p class="mb-0 text-white-50 text-uppercase" style="font-size: 13px;">{{ stripHtml(stat.TitleBn) ||
                stripHtml(stat.TitleEn) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Notice & Calendar -->
  <div class="container mb-5">
    <div class="row justify-content-center g-4 notice-calendar-wrapper">
      <!-- Notices -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="d-flex flex-column h-100">
          <div class="d-flex justify-content-between align-items-center mb-3" style="min-height: 40px;">
            <h4 class="mb-0 fw-bold" style="font-size: 18px; color: #111;">সর্বশেষ নোটিশ</h4>
            <a routerLink="/notice" class="text-success text-decoration-none d-inline-flex align-items-center"
              style="font-size: 14px; font-weight: 600;">সব নোটিশ দেখুন <i class="fa-solid fa-arrow-right ms-2"></i></a>
          </div>
          <div class="border rounded p-3 shadow-sm hover-3d card glassmorphism flex-grow-1"
            style="border-color: var(--border-color) !important; height: 100%;">
            <div class="notice-list d-flex flex-column h-100 justify-content-between">

              <ng-container *ngFor="let item of homeNotices.slice(0, 4); let i = index">
                <div class="notice-item-3d d-flex align-items-center mb-3">

                  <!-- Premium 3D Date Block -->
                  <div class="notice-date-3d flex-shrink-0 me-3"
                    [ngClass]="getNoticeDateBg(i) + ' ' + getNoticeDateText(i)">
                    <div class="date">{{ item.CreatedDate | date:'dd' }}</div>
                    <div class="month">{{ item.CreatedDate | date:'MMM' }}</div>
                  </div>

                  <!-- Notice Content -->
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start mb-1">
                      <a class="notice-title-3d me-3" (click)="onNavigate(item.FileLink)">
                        {{ item.EnglishTitle || item.Title }}
                      </a>
                      <span *ngIf="i === 0" class="badge-new-3d flex-shrink-0 mt-1">নতুন</span>
                    </div>
                    <p class="notice-desc-3d mb-0">
                      {{ stripHtml(item.DetailsBn || item.DetailsEn || '') }}
                    </p>
                  </div>

                  <div class="notice-arrow-3d ms-2">
                    <i class="fa-solid fa-angle-right"></i>
                  </div>

                </div>
              </ng-container>

              <div *ngIf="!homeNotices || homeNotices.length === 0" class="text-center p-3 text-muted">
                No notices available
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Calendar -->
      <div class="col-lg-6">
        <div class="d-flex flex-column h-100">
          <div class="d-flex justify-content-between align-items-center mb-3" style="min-height: 40px;">
            <h4 class="mb-0 fw-bold" style="font-size: 18px; color: #111;">একাডেমিক ক্যালেন্ডার</h4>
            <a routerLink="/calendar" class="text-success text-decoration-none d-inline-flex align-items-center"
              style="font-size: 14px; font-weight: 600;">ক্যালেন্ডার দেখুন <i
                class="fa-solid fa-arrow-right ms-2"></i></a>
          </div>
          <div class="border rounded p-4 shadow-sm hover-3d card glassmorphism flex-grow-1"
            style="border-color: var(--border-color) !important; height: 100%;">
            <!-- Calendar Header -->
            <div class="d-flex justify-content-between align-items-center mb-4 px-2">
              <button class="btn btn-sm btn-link text-dark text-decoration-none px-0" (click)="changeMonth('prev')">
                <i class="fa-solid fa-angle-left fw-bold fs-5"></i>
              </button>
              <h5 class="mb-0 fw-bold" style="font-size: 16px;">{{ getBengaliMonthYear() }}</h5>
              <button class="btn btn-sm btn-link text-dark text-decoration-none px-0" (click)="changeMonth('next')">
                <i class="fa-solid fa-angle-right fw-bold fs-5"></i>
              </button>
            </div>
            <!-- Days Header -->
            <div class="d-flex justify-content-between mb-3 pb-2 border-bottom text-center text-muted"
              style="font-size: 12px; font-weight: 600;">
              <div style="flex: 1;">রবি</div>
              <div style="flex: 1;">সোম</div>
              <div style="flex: 1;">মঙ্গল</div>
              <div style="flex: 1;">বুধ</div>
              <div style="flex: 1;">বৃহস্পতি</div>
              <div style="flex: 1;">শুক্র</div>
              <div style="flex: 1;">শনি</div>
            </div>
            <!-- Days Grid -->
            <div class="d-flex justify-content-between mb-2 text-center fw-bold" style="font-size: 13px;"
              *ngFor="let week of weeks">
              <div *ngFor="let day of week"
                style="flex: 1; height: 35px; display: flex; align-items: center; justify-content: center;">
                <div [class]="getEventClass(day)" style="width: 28px; height: 28px;"
                  [ngClass]="{'text-dark': day.isCurrentMonth, 'text-black-50 fw-normal': !day.isCurrentMonth}">
                  {{ day.date }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Campus Life -->
  <section class="campus-life-section position-relative py-5 mt-5"
    style="background-image: url('assets/img/school/images.jfif'); background-size: cover; background-position: center; background-attachment: fixed; background-repeat: no-repeat;">
    <div
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.6); z-index: 0;">
    </div>
    <div class="container position-relative mb-5 pt-3" style="z-index: 1;">
      <div class="text-center mb-4 d-flex align-items-center justify-content-center">
        <div class="d-flex align-items-center me-3" style="gap: 5px;">
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
        </div>
        <h3 class="fw-bold mb-0" style="font-size: 22px; color: #111;">
          ক্যাম্পাস জীবন
        </h3>
        <div class="d-flex align-items-center ms-3" style="gap: 5px;">
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #111; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
          <div style="width: 5px; height: 5px; background-color: #ffc107; border-radius: 50%;"></div>
        </div>
      </div>

      <div class="row gx-2 gy-3 justify-content-center px-lg-2">
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/classrooms" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('classrooms')" alt="শ্রেণিকক্ষ">
              <div class="campus-card-title">শ্রেণিকক্ষ</div>
            </div>
          </a>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/science-club" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('science-club')" alt="বিজ্ঞান ল্যাব">
              <div class="campus-card-title">বিজ্ঞান ল্যাব</div>
            </div>
          </a>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/library" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('library')" alt="লাইব্রেরি">
              <div class="campus-card-title">লাইব্রেরি</div>
            </div>
          </a>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/sports" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('sports')" alt="খেলাধুলা">
              <div class="campus-card-title">খেলাধুলা</div>
            </div>
          </a>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/cultural-club" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('cultural-club')" alt="সাংস্কৃতিক অনুষ্ঠান">
              <div class="campus-card-title">সাংস্কৃতিক অনুষ্ঠান</div>
            </div>
          </a>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <a routerLink="/computer--club" class="text-decoration-none">
            <div class="campus-card premium-3d-card">
              <img [src]="getCampusLifeImage('computer--club')" alt="কম্পিউটার ল্যাব">
              <div class="campus-card-title">কম্পিউটার ল্যাব</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Galleries -->
  <div class="container mb-5">
    <div class="row justify-content-center g-4">

      <!-- Image Gallery -->
      <div class="col-lg-4 col-md-6">
        <div class="gallery-card h-100 hover-3d card glassmorphism p-3 d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-bold mb-0" style="font-size: 16px;">ছবির গ্যালারি</h4>
            <a routerLink="/photo-gallery" class="text-success text-decoration-none"
              style="font-size: 12px; font-weight: 600;">সব দেখুন <i class="fa-solid fa-arrow-right"></i></a>
          </div>
          <div class="flex-grow-1"
            style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; align-content: space-between;">
            <ng-container *ngFor="let item of ImageAlbumShown; let i = index">
              <a href="javascript:void(0)"
                (click)="openImageModal(item.ThumbnailLink ? TransformUrl(item.ThumbnailLink) : '/assets/img/school/logo.png', item.Name || 'Gallery Image')"
                class="d-block text-decoration-none image-gallery-item rounded overflow-hidden bg-light"
                style="aspect-ratio: 16/9;">
                <img [src]="item.ThumbnailLink ? TransformUrl(item.ThumbnailLink) : '/assets/img/school/logo.png'"
                  [alt]="item.Name || 'Gallery Image'" class="w-100 h-100 object-fit-cover">
                <div class="image-gallery-overlay">
                  <i class="fa-solid fa-magnifying-glass-plus"></i>
                </div>
              </a>
            </ng-container>

          </div>
        </div>
      </div>

      <!-- Video Gallery -->
      <div class="col-lg-4 col-md-6">
        <div class="gallery-card h-100 hover-3d card glassmorphism p-3 d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-bold mb-0" style="font-size: 16px;">ভিডিও গ্যালারি</h4>
            <a routerLink="/video-gallery" class="text-success text-decoration-none"
              style="font-size: 12px; font-weight: 600;">সব দেখুন <i class="fa-solid fa-arrow-right"></i></a>
          </div>
          <div class="d-flex flex-column justify-content-between flex-grow-1" style="gap: 6px;">
            <!-- Main Video -->
            <a *ngIf="VideoAlbumShown.length > 0" [routerLink]="['/videoFolder', VideoAlbums[0].Id]"
              class="d-block text-decoration-none">
              <div class="rounded overflow-hidden position-relative bg-dark" style="aspect-ratio: 16/6.3;">
                <img *ngIf="VideoAlbumShown[0].VideoId" [src]="getYouTubeThumbnail(VideoAlbumShown[0].VideoId)"
                  class="w-100 h-100 object-fit-cover opacity-75">
                <div class="position-absolute top-50 start-50 translate-middle">
                  <div class="rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 44px; height: 44px; background: rgba(0,0,0,0.2); border: 2px solid white;">
                    <i class="fa-solid fa-play text-white ms-1"></i>
                  </div>
                </div>
              </div>
            </a>

            <div *ngIf="VideoAlbumShown.length === 0" class="rounded overflow-hidden position-relative bg-dark"
              style="aspect-ratio: 16/6.3;">
              <div class="position-absolute top-50 start-50 translate-middle">
                <div class="rounded-circle d-flex align-items-center justify-content-center"
                  style="width: 44px; height: 44px; background: rgba(0,0,0,0.5); border: 2px solid white;">
                  <i class="fa-solid fa-play text-white ms-1"></i>
                </div>
              </div>
            </div>

            <!-- Small Videos -->
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px;">
              <ng-container *ngFor="let item of VideoAlbumShown | slice:1:4; let i = index">
                <a [routerLink]="['/videoFolder', VideoAlbums[0].Id]" class="d-block text-decoration-none h-100 w-100">
                  <div class="rounded overflow-hidden position-relative bg-dark h-100 w-100"
                    style="aspect-ratio: 16/9;">
                    <img *ngIf="item.VideoId" [src]="getYouTubeThumbnail(item.VideoId)"
                      class="w-100 h-100 object-fit-cover opacity-75">
                    <div class="position-absolute top-50 start-50 translate-middle">
                      <div class="rounded-circle d-flex align-items-center justify-content-center"
                        style="width: 24px; height: 24px; background: rgba(0,0,0,0.2); border: 1.5px solid white;">
                        <i class="fa-solid fa-play text-white ms-1" style="font-size: 10px;"></i>
                      </div>
                    </div>
                  </div>
                </a>
              </ng-container>
              <ng-container
                *ngFor="let empty of [].constructor(VideoAlbumShown.length > 0 ? (4 - VideoAlbumShown.length < 0 ? 0 : 4 - VideoAlbumShown.length) : 3)">
                <div class="rounded overflow-hidden position-relative bg-dark h-100 w-100">
                  <div class="position-absolute top-50 start-50 translate-middle">
                    <div class="rounded-circle d-flex align-items-center justify-content-center"
                      style="width: 24px; height: 24px; background: rgba(0,0,0,0.5); border: 1.5px solid white;">
                      <i class="fa-solid fa-play text-white ms-1" style="font-size: 10px;"></i>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Event Gallery -->
      <div class="col-lg-4 col-md-12">
        <div class="gallery-card h-100 hover-3d card glassmorphism p-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-bold mb-0" style="font-size: 16px;">ইভেন্ট গ্যালারি</h4>
            <a routerLink="/news-and-events" class="text-success text-decoration-none"
              style="font-size: 12px; font-weight: 600;">সব দেখুন <i class="fa-solid fa-arrow-right"></i></a>
          </div>
          <div class="d-flex flex-column justify-content-between flex-grow-1" style="gap: 10px;">

            <div class="d-flex align-items-center p-1 rounded"
              style="background-color: transparent; border: 1px solid var(--border-color);"
              *ngFor="let item of foundnews | slice:0:3; let i = index">
              <div
                class="notice-date text-white text-center rounded d-flex flex-column justify-content-center me-2 shadow-sm"
                style="width: 55px; height: 55px; background-color: #026928; flex-shrink: 0;">
                <div class="fw-bold" style="font-size: 20px; line-height: 1;">{{ (item.CurrentDate | date:'dd') || '01'
                  }}</div>
                <div style="font-size: 10px; font-weight: 600; margin-top: 2px;">{{ (item.CurrentDate | date:'MMM') ||
                  'Jan' }}</div>
              </div>
              <div class="flex-grow-1 px-3" style="min-width: 0;">
                <a class="fw-bold text-dark text-decoration-none d-block text-truncate" style="font-size: 14px;">{{
                  item.TitleBn || item.TitleEn || 'Notice' }}</a>
                <div class="mb-0 text-muted text-truncate" style="font-size: 11px;">
                  {{ stripHtml(item.DetailsBn || item.DetailsEn) || 'অনুষ্ঠান সফলভাবে সম্পন্ন হয়েছে।' }}
                </div>
              </div>
              <div class="flex-shrink-0">
                <img
                  [src]="item.ShowAttachments && item.ShowAttachments.length > 0 ? item.ShowAttachments[0].FilePath : '/assets/img/school/logo.png'"
                  class="rounded object-fit-cover" style="width: 75px; height: 55px;" alt="">
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</section>

<!-- Image Preview Modal -->
<div class="modal fade" id="imagePreviewModal" tabindex="-1" aria-hidden="true"
  style="backdrop-filter: blur(5px); background: rgba(0, 0, 0, 0.75);">
  <div class="modal-dialog modal-dialog-centered modal-xl position-relative">
    <div class="modal-content bg-transparent border-0 overflow-visible">

      <!-- Floating Close Button -->
      <button type="button" class="premium-close-btn d-none d-md-flex" data-bs-dismiss="modal" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>

      <div class="modal-body text-center p-0 position-relative">
        <!-- Mobile close button -->
        <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3 d-md-none"
          data-bs-dismiss="modal" style="z-index: 10;"></button>

        <img [src]="selectedImageModalUrl" class="img-fluid premium-modal-img w-100" [alt]="selectedImageModalName"
          style="max-height: 90vh; object-fit: contain;">

        <h5 class="text-white mt-4 mb-0 fw-bold"
          style="font-family: 'Inter', sans-serif; letter-spacing: 0.5px; text-shadow: 0 2px 8px rgba(0,0,0,0.5);">
          {{selectedImageModalName}}
        </h5>
      </div>

    </div>
  </div>
</div>

<!-- Fixed Notice Scroll (Fixed Top workaround) -->
<div class="important-news-bar"
  style="display: block !important; visibility: visible !important; opacity: 1 !important; z-index: 2147483647 !important; top: calc(100dvh - 48px - env(safe-area-inset-bottom, 0px)) !important; position: fixed !important; height: calc(48px + env(safe-area-inset-bottom, 0px)) !important; padding-bottom: env(safe-area-inset-bottom, 0px) !important; width: 100% !important; margin: 0 !important; left: 0 !important;">
  <div class="container p-0" style="height: 100% !important; max-width: 100% !important;">
    <div class="d-flex" style="height: 100% !important; flex-wrap: nowrap !important; overflow: hidden !important;">
      <div class="notice-label d-flex align-items-center justify-content-center px-2 px-md-4"
        style="flex-shrink: 0 !important; height: 100% !important;">
        <i class="fa-solid fa-bell me-1 me-md-2"></i> <span class="d-none d-md-inline">সর্বশেষ&nbsp;</span>নোটিশ
      </div>
      <div class="notice-marquee-container flex-grow-1"
        style="min-width: 50px !important; height: 100% !important; overflow: hidden !important;">
        <marquee scrollamount="4" behavior="scroll" direction="left" class="d-flex align-items-center"
          style="height: 100% !important;">
          <span *ngFor="let item of homeNotices" class="notice-marquee-item me-5" (click)="onNavigate(item.FileLink)">
            <i class="fa-solid fa-chevron-right me-2" style="color: #dc3545;"></i> {{ stripHtml(item.TitleBn ||
            item.EnglishTitle || item.Title) }}
          </span>
        </marquee>
      </div>
      <a routerLink="/notice"
        class="notice-view-all d-none d-md-flex align-items-center justify-content-center px-2 px-md-4 text-decoration-none"
        style="flex-shrink: 0 !important; height: 100% !important;">
        সকল নোটিশ <i class="fa-solid fa-angle-right ms-1 ms-md-2"></i>
      </a>
    </div>
  </div>
</div>